import { useEffect, useState } from "react";
import { Page } from "../Page";
import { SidebarAccordionModule } from "../Sidebar/Accordian";
import { SidebarHeadline } from "../Sidebar/SidebarHeadline";
import { PanelWorkingCapital } from "./PanelWorkingCapital/PanelWorkingCapital";
import { ModuleBuyers } from "./Sidebar/ModuleBuyer";
import { ModuleNetWorkingCapital } from "./Sidebar/ModuleNetWorkingCapital";
import { ModuleSellerProvidedWorkingCapital } from "./Sidebar/ModuleSellerProvidedWorkingCapital";

const modules: SidebarAccordionModule[] = [
  ModuleNetWorkingCapital,
  ModuleSellerProvidedWorkingCapital,
  ModuleBuyers,
];

export const WorkingCapitalPage = () => {
  // give time for sidebar atoms to calculate
  // so we dont redo calcs
  const [renderMain, setRenderMain] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setRenderMain(true);
    }, 25);
  }, []);

  return (
    <Page
      sidebarTop={
        <SidebarHeadline
          title={"NWC Navigator"}
          docPath={"@/docs/pages/model/working-capital/getting-started.mdx"}
        />
      }
      sidebarModules={modules}
      accordionId={"workingCapitalAccordion"}
    >
      {renderMain && <PanelWorkingCapital />}
    </Page>
  );
};
